module.exports = __webpack_public_path__ + "img/widescreen.0a76ee78.svg";